import { Alert, AlertTitle, Box, Typography, useTheme } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';

// ==============================|| DELIVERY DRIVER WEB APP DEPRECATION BANNER ||============================== //

type Props = {
    visible?: boolean;
};

const DeliveryDriverWebDeprecationBanner = ({ visible }: Props) => {
    const theme = useTheme();

    // Only show if user is a delivery driver
    if (!visible) {
        return null;
    }

    return (
        <Alert 
            severity="info" 
            icon={<InfoIcon />}
            sx={{ 
                backgroundColor: theme.palette.secondary.light,
                marginBottom: 4,
                paddingTop: 2,
                paddingBottom: 2,
                '& .MuiAlert-icon': {
                    color: theme.palette.secondary.main
                },
            }}
        >
            <Box sx={{ width: '100%' }}>
                <AlertTitle sx={{ color: theme.palette.secondary.main, fontWeight: 'bold', marginBottom: 1 }}>
                    Important Notice: Delivery Driver Web Interface Deprecation
                </AlertTitle>
                <Typography variant="body2" sx={{ color: theme.palette.secondary.main }}>
                    Future updates and new features will not be made available on this web interface. 
                    We recommend that all delivery drivers install and use the mobile app for the best experience. 
                    In case you cannot access the mobile app, the web interface will continue to support the 
                    ability to sign up for and finish routes.
                    <br/><br/>
                    Please contact support at support@kneadtech.com if you have any questions.
                </Typography>
            </Box>
        </Alert>
    );
};

export default DeliveryDriverWebDeprecationBanner;
